import { render, staticRenderFns } from "./EmbedNavigation.vue?vue&type=template&id=429e48b5"
import script from "./EmbedNavigation.vue?vue&type=script&lang=js"
export * from "./EmbedNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports